import React, { Component } from 'react'
import Api from '../../services/api'

/**
 * Renders a lot video that lives in a private S3 bucket. A direct GET on
 * `file.url` returns 403, so we fetch a presigned URL by `file.key` and only
 * then attach the <source>. Rendering the source before the URL resolves would
 * trigger a 403 `onError` (which the carousel treats as "remove this video").
 */
export default class SignedVideo extends Component {
  constructor (props) {
    super(props)
    this.state = { url: null }
    this.videoRef = React.createRef()
    this.isUnmounted = false
  }

  componentDidMount () {
    this.resolveUrl()
  }

  componentWillUnmount () {
    this.isUnmounted = true
  }

  async resolveUrl () {
    const { file } = this.props
    if (file && file.key) {
      // Reuse the existing signed-url endpoint (same one documents use) — it
      // signs by object key against the private media bucket.
      const res = await Api.getSignedUrl(file.key)
      if (this.isUnmounted) {
        return
      }
      if (res && res.url) {
        this.setState({ url: res.url }, () => {
          // a <video> won't pick up a newly-added <source> without load()
          if (this.videoRef.current) {
            this.videoRef.current.load()
          }
        })
        return
      }
    }
    // Fall back to whatever url we already have (e.g. a freshly-picked
    // local data URL that hasn't been uploaded yet).
    this.setState({ url: file ? file.url : null })
  }

  render () {
    const { file, className, lot, poster, onError, onReady } = this.props
    const { url } = this.state
    return (
      <video
        ref={this.videoRef}
        id={file.key}
        className={className}
        controls={!lot}
        poster={poster !== undefined ? poster : file.thumbnail}
        onError={onError}
        onLoadedMetadata={onReady}
        muted
        playsInline
      >
        {url && <source src={url} type={file.mimeType} />}
      </video>
    )
  }
}
